import { AuthRole } from '@newfront-insurance/auth-api';
import { useHasAnyScope } from '@newfront-insurance/next-auth';

import { AuthSwapProvider } from '@/client/providers/auth';

export default function useIsAdmin(): boolean {
  return useHasAnyScope(AuthSwapProvider, [AuthRole.CLIENT_ADMIN]);
}
